// extracted by mini-css-extract-plugin
export default {"wrapper":"AdditionalInfo_wrapper__x4BzP"};